import { fmtB } from '@dcc-erp/shared';

// Collection-forecast widget (ART-18). Reuses the dashboard bar-chart CSS
// (.bars / .bcol / .bstack / .b1 / .blabel from prototype.css) to render the
// projected AR collections for the next few weeks. It takes a NORMALIZED prop
// so it stays decoupled from the exact CashflowForecastResponse shape — the
// /ar route maps the AR_COL category row's weekly inflows into `weeks`.
// Plain prototype.css only — no tailwind.

export interface CollectionForecastWeek {
  label: string;
  collections: number;
}

export interface CollectionForecastProps {
  weeks: CollectionForecastWeek[];
}

export function CollectionForecast({ weeks }: CollectionForecastProps) {
  // Scale bar heights to the tallest week so the chart fills its box; guard
  // against an all-zero (or empty) forecast so we never divide by zero.
  const maxBar = Math.max(1, ...weeks.map((w) => w.collections));

  return (
    <div className="bars">
      {weeks.map((w, i) => (
        <div className="bcol" key={i}>
          <div className="bstack">
            <div
              data-testid="forecast-bar"
              className="b1"
              style={{ height: `${(w.collections / maxBar) * 100}%` }}
              title={`${w.label} · ${fmtB(w.collections)} บาท`}
            />
          </div>
          <div className="blabel">{w.label}</div>
        </div>
      ))}
    </div>
  );
}
